import { PermissionT } from "../types";

export const adminDashboardView = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "admin_dashboard_view");
  return !!p;
};

export default adminDashboardView;
